module.exports = __webpack_public_path__ + "assets/img/img-talk-01-sp.59c20cb7.jpg";